"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDropdownArrowIcon = exports.encodeSvg = exports.IconStyle = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var PreventUserSelect_1 = require("../styles/PreventUserSelect");
var TypedKeys_1 = require("../utils/TypedKeys");
var DomWidgets_1 = require("../widgets/DomWidgets");
var IconDropdownArrow_1 = require("./resources/IconDropdownArrow");
exports.IconStyle = tslib_1.__assign(tslib_1.__assign({}, PreventUserSelect_1.PreventUserSelectSansCursor), { flexShrink: 0 });
var svgDataUriRegExp = /^data:image\/svg\+xml/;
/**
 * Encodes a raw SVG file (i.e. a string that looks like `<svg ...`) into a data URI,
 * which can then be used as a `src` for `<img>` elements, CSS `background-image`, etc.
 *
 * If the provided string is already encoded, no-op.
 */
function encodeSvg(svg) {
    return svgDataUriRegExp.test(svg) ? svg : "data:image/svg+xml," + encodeURIComponent(svg);
}
exports.encodeSvg = encodeSvg;
/** This is only applicable to our remaining local string-replace icons found in src/icons/resources */
function formatSvg(svgImport, state) {
    if (state === void 0) { state = {}; }
    var classList = TypedKeys_1.typedKeys(state).filter(function (key) { return !!(state)[key]; }).join(' ');
    return encodeSvg(svgImport.replace('$state$', classList));
}
var IconDropdownArrowIconElement = function (props) {
    var active = props.active, className = props.className, disabled = props.disabled, hover = props.hover, onDarkBackground = props.onDarkBackground, svgProps = tslib_1.__rest(props, ["active", "className", "disabled", "hover", "onDarkBackground"]);
    return React.createElement(DomWidgets_1.Img, tslib_1.__assign({}, svgProps, { 
        // This change will increase the size of DropdownButtonType.Icon instances by 4px, so waiting to push it out.
        // const IconDropdownArrowSvg = ArrowTriangleDownIconRaw(12, TabStyles.Colors.L8);
        src: formatSvg(IconDropdownArrow_1.IconDropdownArrowSvg, { active: active, disabled: disabled, hover: hover, onDarkBackground: onDarkBackground }) }));
};
exports.IconDropdownArrowIcon = {
    height: 5,
    width: 7,
    icon: IconDropdownArrowIconElement,
};
//# sourceMappingURL=Icons.js.map